/**
 * TTL付きのLocalStorage
 */

const defaultTTLSec = 60 * 30 // 30 minutes
const cookiePath = 'secure;Path=/;'
const cookieAgeHead = 'Max-age='
interface LsCacheItem {
  expireAt: number // 登録時間
  value: any
  TTLSec: number
}
class LsCache {
  /**
   * TTL付きでLocalStorageに保存
   * @param key - 登録するKey名
   * @param val - 登録する値
   * @param TTLInSeconds - 秒数を指定（マイナス値の場合は、defaultTTLSecの値を使用）
   */
  set(key: string, val: any, TTLInSeconds: number | -1 = defaultTTLSec): boolean {
    if (TTLInSeconds < 0) {
      TTLInSeconds = defaultTTLSec
    }
    const item: LsCacheItem = {
      expireAt: this._now + TTLInSeconds * 1000,
      value: val,
      TTLSec: TTLInSeconds,
    }
    try {
      const cookieAge = cookieAgeHead + TTLInSeconds + ';'
      const cookieValue = encodeURIComponent(JSON.stringify(item)) + ';'
      const cookie = key + '=' + cookieValue + cookieAge + cookiePath
      document.cookie = cookie
      return true
    } catch (e) {
      return false
    }
  }
  get _now(): number {
    return new Date().getTime()
  }
  get(key) {
    const cookies = document.cookie.split(';')
    let cookieString = ''
    for (let index in cookies) {
      let content = cookies[index].split('=')
      if (content[0].trim() == key) {
        cookieString = decodeURIComponent(content[1])
        break
      }
    }
    if (!cookieString) {
      return null
    }
    const cookieValue: LsCacheItem = JSON.parse(cookieString)
    this.set(key, cookieValue.value, cookieValue.TTLSec)
    return cookieValue.value
  }
  clear(key) {
    const cookieAge = cookieAgeHead + '0;'
    document.cookie = key + '=;' + cookieAge + cookiePath
  }
  async getWithFetchFunc(key, fetchFunction: Function, TTLInSeconds = defaultTTLSec) {
    const cached = this.get(key)
    if (cached) {
      return cached
    }
    const fetched = await fetchFunction()
    this.set(key, fetched, TTLInSeconds)
    return fetched
  }
}

export const $lsCache = new LsCache()
